export default {
  routerList: [
    // 业务订单————运单管理
    {
      path: "/WaybillManage/NewPickupInstructionList",
      component: (resolve) =>
        require([
          "@/pages/BusinessOrder/WaybillManage/NewPickupInstruction/List",
        ], resolve),
      meta: {
        title: "提货指令列表",
        keepAlive: true,
      },
    },
    {
      path: "/WaybillManage/NewPickupInstructionAddEdit",
      component: (resolve) =>
        require([
          "@/pages/BusinessOrder/WaybillManage/NewPickupInstruction/AddEdit",
        ], resolve),
      meta: {
        title: "提货指令",
        keepAlive: true,
      },
    },
    //待外发录入列表
    {
      path: "/OutgoingManage/PendingOutboundEntry/List",
      component: (resolve) =>
        require([
          "@/pages/BusinessOrder/OutgoingManage/PendingOutboundEntry/List",
        ], resolve),
      meta: {
        title: "待外发录入列表",
        keepAlive: true,
      },
    },
    {
      path: "/OutgoingManage/PendingOutboundEntry/SettlementEntry",
      component: (resolve) =>
        require([
          "@/pages/BusinessOrder/OutgoingManage/PendingOutboundEntry/SettlementEntry",
        ], resolve),
      meta: {
        title: "结算录入",
        keepAlive: true,
      },
    },
    {
      path: "/OutgoingManage/OutgoingTracking",
      component: (resolve) =>
        require([
          "@/pages/BusinessOrder/OutgoingManage/OutgoingTracking",
        ], resolve),
      meta: {
        title: "外发跟踪",
        keepAlive: true,
      },
    },
    {
      path: "/ExceptionManage/UnqualifiedList",
      component: (resolve) =>
        require([
          "@/pages/BusinessOrder/ExceptionManage/UnqualifiedList/List",
        ], resolve),
      meta: {
        title: "不合格服务列表",
        keepAlive: true,
      },
    },
    {
      path: "/ExceptionManage/UnqualifiedList/NewBuilt",
      component: (resolve) =>
        require([
          "@/pages/BusinessOrder/ExceptionManage/UnqualifiedList/NewBuilt",
        ], resolve),
      meta: {
        title: "不合格服务",
        keepAlive: true,
      },
    },
    {
      path: "/ExceptionManage/AbnormalSummaryTable",
      component: (resolve) =>
        require([
          "@/pages/BusinessOrder/ExceptionManage/AbnormalSummaryTable",
        ], resolve),
      meta: {
        title: "异常总表",
        keepAlive: true,
      },
    },
    {
      path: "/ExceptionManage/AbnormalTableCustomers",
      component: (resolve) =>
        require([
          "@/pages/BusinessOrder/ExceptionManage/AbnormalTableCustomers",
        ], resolve),
      meta: {
        title: "异常表-客户",
        keepAlive: true,
      },
    },
    {
      path: "/DataImport/WaybillImport",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/DataImport/WaybillImport"], resolve),
      meta: {
        title: "运单导入-客户",
        keepAlive: true,
      },
    },
    {
      path: "/DataImport/OutgoingImport",
      component: (resolve) =>
          require(["@/pages/BusinessOrder/DataImport/OutgoingImport"], resolve),
      meta: {
        title: "外发单导入",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/PickupScheduling",
      component: (resolve) =>
        require([
          "@/pages/DispatchCar/PickupScheduling/PickupScheduling",
        ], resolve),
      meta: {
        title: "提货调度",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/WaybillLoading",
      component: (resolve) =>
        require(["@/pages/DispatchCar/WaybillLoading/WaybillLoading"], resolve),
      meta: {
        title: "运单配载",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/ReceivingDispatcher",
      component: (resolve) =>
        require([
          "@/pages/DispatchCar/ReceivingDispatcher/ReceivingDispatcher",
        ], resolve),
      meta: {
        title: "接收调度员",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/DeliveryScheduling",
      component: (resolve) =>
        require([
          "@/pages/DispatchCar/DeliveryScheduling/DeliveryScheduling",
        ], resolve),
      meta: {
        title: "送货调度",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/DeliveryScheduling/MultipleTicketDelivery",
      component: (resolve) =>
        require([
          "@/pages/DispatchCar/DeliveryScheduling/MultipleTicketDelivery",
        ], resolve),
      meta: {
        title: "多票派车",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/OutgoingDispatch",
      component: (resolve) =>
        require([
          "@/pages/DispatchCar/OutgoingDispatch/OutgoingDispatch",
        ], resolve),
      meta: {
        title: "外发调度",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/DispatchCar",
      component: (resolve) =>
        require(["@/pages/DispatchCar/OutgoingDispatch/DispatchCar"], resolve),
      meta: {
        title: "外发派车",
        keepAlive: true,
      },
    },
    // {
    //   path: "/DispatchCar/MainlineDispatch",
    //   component: (resolve) =>
    //     require([
    //       "@/pages/DispatchCar/MainlineDispatch/MainlineDispatch",
    //     ], resolve),
    //   meta: {
    //     title: "干线调度",
    //     keepAlive: true,
    //   },
    // },
    // {
    //   path: "/DispatchCar/VehicleTrajectoryQuery",
    //   component: (resolve) =>
    //     require([
    //       "@/pages/DispatchCar/VehicleTrajectoryQuery/VehicleTrajectoryQuery",
    //     ], resolve),
    //   meta: {
    //     title: "车辆轨迹查询",
    //     keepAlive: true,
    //   },
    // },
    {
      path: "/DispatchCar/VehicleStowage/ExpenseEntry",
      component: (resolve) =>
        require(["@/pages/DispatchCar/VehicleStowage/ExpenseEntry"], resolve),
      meta: {
        title: "费用录入",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/VehicleStowage/ExpenseSupplementaryRecording",
      component: (resolve) =>
        require([
          "@/pages/DispatchCar/VehicleStowage/ExpenseSupplementaryRecording",
        ], resolve),
      meta: {
        title: "费用补录",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/LoadedTasks",
      component: (resolve) =>
        require(["@/pages/DispatchCar/LoadedTasks/LoadedTasks"], resolve),
      meta: {
        title: "已配载任务",
        keepAlive: true,
      },
    },
    {
      path: "/WarehouseManagement/WaybillSorted",
      component: (resolve) =>
        require(["@/pages/WarehouseManagement/Sorting/WaybillSorted"], resolve),
      meta: {
        title: "待分拣运单",
        keepAlive: true,
      },
    },
    {
      path: "/WarehouseManagement/PackagingSorting",
      component: (resolve) =>
        require([
          "@/pages/WarehouseManagement/Sorting/PackagingSorting",
        ], resolve),
      meta: {
        title: "包装分拣",
        keepAlive: true,
      },
    },
    {
      path: "/WarehouseManagement/sortingAddEdit",
      component: (resolve) =>
        require([
          "@/pages/WarehouseManagement/Sorting/sortingAddEdit",
        ], resolve),
      meta: {
        title: "分拣",
        keepAlive: true,
      },
    },
    {
      path: "/FinancialManagement/ExpenseReimbursement",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/ExpenseReimbursement/ExpenseReimbursement",
        ], resolve),
      meta: {
        title: "费用报销",
        keepAlive: true,
      },
    },
    {
      path: "/FinancialManagement/ExpenseReimbursement/NewModificationDetails",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/ExpenseReimbursement/NewModificationDetails",
        ], resolve),
      meta: {
        title: "费用报销单",
        keepAlive: true,
      },
    },
    {
      path:
        "/FinancialManagement/FinancialWriteOff/CustomerVerificationSummary",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/FinancialWriteOff/CustomerVerificationSummary",
        ], resolve),
      meta: {
        title: "客户核销总表",
        keepAlive: true,
      },
    },
    {
      path: "/FinancialManagement/FinancialWriteOff/CarrierVerificationSummary",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/FinancialWriteOff/CarrierVerificationSummary",
        ], resolve),
      meta: {
        title: "承运商核销总表",
        keepAlive: true,
      },
    },
    {
      path: "/FM/DebitNote",
      component: (resolve) =>
        require(["@/pages/FinancialManagement/FAMS/DebitNote"], resolve),
      meta: {
        title: "借支单",
        keepAlive: true,
      },
    },
    {
      path: "/FM/InvoicesControlRX",
      component: (resolve) =>
        require(["@/pages/FinancialManagement/InvoicesControlRX"], resolve),
      meta: {
        title: "发票管理",
        keepAlive: true,
      },
    },
    {
      path: "/FM/InvoicesControlRX/InvoicesAddRX",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/InvoicesControlMOD/InvoicesAddRX",
        ], resolve),
      meta: {
        title: "开票",
        keepAlive: true,
      },
    },
    // 报表
    {
      path: "/FM/ReportManager",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/ReportManager/ReportManager",
        ], resolve),
      meta: {
        title: "报表管理",
        keepAlive: true,
      },
    },
    {
      path: "/FM/ReportManager/AccountsReceivableDetails",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/ReportManager/AccountsReceivableDetails",
        ], resolve),
      meta: {
        title: "应收账款明细",
        keepAlive: true,
      },
    },
    {
      path: "/FM/ReportManager/CustomerAccountsReceivableStatusTable",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/ReportManager/CustomerAccountsReceivableStatusTable",
        ], resolve),
      meta: {
        title: "客户应收账款情况表",
        keepAlive: true,
      },
    },
    {
      path: "/FM/ReportManager/CarrierAccountsPayableStatusTable",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/ReportManager/CarrierAccountsPayableStatusTable",
        ], resolve),
      meta: {
        title: "承运商应付账款情况表",
        keepAlive: true,
      },
    },
    {
      path: "/FM/ReportManager/ReimbursementPayableStatistics",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/ReportManager/ReimbursementPayableStatistics",
        ], resolve),
      meta: {
        title: "报销应付统计",
        keepAlive: true,
      },
    },
    {
      path: "/FM/ReportManager/WaybillIncomeStatement",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/ReportManager/WaybillIncomeStatement",
        ], resolve),
      meta: {
        title: "运单损益表",
        keepAlive: true,
      },
    },
    {
      path: "/FM/ReportManager/MonthlyAccountsReceivableSummary",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/ReportManager/MonthlyAccountsReceivableSummary",
        ], resolve),
      meta: {
        title: "月应收汇总",
        keepAlive: true,
      },
    },
    {
      path: "/FM/ReportManager/CustomerShipmentDataDashboard",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/ReportManager/CustomerShipmentDataDashboard",
        ], resolve),
      meta: {
        title: "客户发货数据看板",
        keepAlive: true,
      },
    },
    {
      path: "/FM/ReportManager/CustomerServiceStatistics",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/ReportManager/CustomerServiceStatistics",
        ], resolve),
      meta: {
        title: "客服统计",
        keepAlive: true,
      },
    },
    {
      path: "/FM/ReportManager/OperationalDataStatisticsReportOperations",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/ReportManager/OperationalDataStatisticsReportOperations",
        ], resolve),
      meta: {
        title: "操作数据统计报表（运营）",
        keepAlive: true,
      },
    },
    {
      path: "/FM/ReportManager/WaybillCostDetails",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/ReportManager/WaybillCostDetails",
        ], resolve),
      meta: {
        title: "运单成本明细表",
        keepAlive: true,
      },
    },
    {
      path: "/FM/ReportManager/ListOfOperatingPersonnel",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/ReportManager/ListOfOperatingPersonnel",
        ], resolve),
      meta: {
        title: "运营操作人员明细表",
        keepAlive: true,
      },
    },
    {
      path: "/FM/ReportManager/SystemOperationStatistics",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/ReportManager/SystemOperationStatistics",
        ], resolve),
      meta: {
        title: "系统操作统计",
        keepAlive: true,
      },
    },
    {
      path: "/Customers/NVOCCCarrierQuotation",
      component: (resolve) =>
        require(["@/pages/Customers/NVOCCCarrierQuotation"], resolve),
      meta: {
        title: "承运商报价",
        keepAlive: true,
      },
    },
    {
      path: "/Customers/NVOCCLineQuotation",
      component: (resolve) =>
        require(["@/pages/Customers/NVOCCLineQuotation"], resolve),
      meta: {
        title: "承运商报价方案明细",
        keepAlive: true,
      },
    },
    {
      path: "/Customers/CustomCarrierQuotation",
      component: (resolve) =>
        require(["@/pages/Customers/CustomCarrierQuotation"], resolve),
      meta: {
        title: "客户报价",
        keepAlive: true,
      },
    },
    {
      path: "/Customers/CustomLineQuotation",
      component: (resolve) =>
        require(["@/pages/Customers/CustomLineQuotation"], resolve),
      meta: {
        title: "客户报价方案明细",
        keepAlive: true,
      },
    },
    {
      path: "/VMS/VehicleInsurance",
      component: (resolve) =>
        require(["@/pages/VMS/VehicleInsurance"], resolve),
      meta: {
        title: "车辆保险",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/AddressBook",
      component: (resolve) =>
        require(["@/pages/SystemSetting/AddressBook"], resolve),
      meta: {
        title: "地址薄",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/InvoiceHeader",
      component: (resolve) =>
        require(["@/pages/SystemSetting/InvoiceHeader"], resolve),
      meta: {
        title: "发票抬头",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/Qualifications",
      component: (resolve) =>
        require(["@/pages/SystemSetting/Qualifications"], resolve),
      meta: {
        title: "企业资质",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/BasicDataConfiguration",
      component: (resolve) =>
        require(["@/pages/SystemSetting/BasicDataConfiguration"], resolve),
      meta: {
        title: "基础数据配置",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/AbnormalCause",
      component: (resolve) =>
        require(["@/pages/SystemSetting/AbnormalCause"], resolve),
      meta: {
        title: "异常原因",
        keepAlive: true,
      },
    },
  ],
};
